export default {
  path: '/index',
  name: 'index',
  redirect: {
    name: 'memberCenter'
  },
  component: function component() {
    return import('@/layouts/basic-layout');
  },
  children: [{
    path: 'memberCenter',
    name: 'memberCenterSon',
    meta: {
      title: '我的首页',
      closable: false
    },
    component: function component() {
      return import('@/pages/memberCenter/memberCenter');
    }
  }, // 我的首页-我的账号-账号信息管理
  {
    path: 'accountInfoManage',
    name: 'accountInfoManage',
    meta: {
      title: '账号信息管理',
      isCheckMenu: true,
      belongMenus: ['accountInfoManage']
    },
    component: function component() {
      return import('@/pages/memberCenter/myAccountMenu/accountInfoManage/accountInfoManage');
    }
  }, // 我的首页-我的账号-账号信息编辑
  {
    path: 'accountInfoEdit',
    name: 'accountInfoEdit',
    meta: {
      title: '账号信息编辑',
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/myAccountMenu/accountInfoManage/accountInfoEdit');
    }
  }, // 我的首页-我的账号-账号安全管理
  {
    path: 'accountSecurityManage',
    name: 'accountSecurityManage',
    meta: {
      title: '账号安全管理',
      isCheckMenu: true,
      belongMenus: ['accountSecurityManage']
    },
    component: function component() {
      return import('@/pages/memberCenter/myAccountMenu/accountSecurityManage/accountSecurityManage');
    }
  }, // 我的首页-我的账号-收货地址管理
  {
    path: 'receiveAddressList',
    name: 'receiveAddressList',
    meta: {
      title: '收货地址管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['receiveAddressList']
    },
    component: function component() {
      return import('@/pages/memberCenter/myAccountMenu/receiveAddressList/receiveAddressList');
    }
  }, // 我的首页-我的账号-收货地址管理-新增
  {
    path: 'receiveAddressAdd',
    name: 'receiveAddressAdd',
    meta: {
      title: '收货地址新增',
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/myAccountMenu/receiveAddressList/receiveAddressAdd');
    }
  }, // 我的首页-我的账号-收货地址管理-编辑
  {
    path: 'receiveAddressEdit',
    name: 'receiveAddressEdit',
    meta: {
      title: '收货地址编辑',
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/myAccountMenu/receiveAddressList/receiveAddressEdit');
    }
  }, // 我的首页-我的账号-收货地址管理-详情
  {
    path: 'receiveAddressDetail',
    name: 'receiveAddressDetail',
    meta: {
      title: '收货地址详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/myAccountMenu/receiveAddressList/receiveAddressDetail');
    }
  }, // 我的首页-我的收藏
  {
    path: 'myFavorite',
    name: 'myFavorite',
    meta: {
      title: '我的收藏',
      isCheckMenu: true,
      belongMenus: ['myFavorite']
    },
    component: function component() {
      return import('@/pages/memberCenter/myAccountMenu/myFavorite/myFavorite');
    }
  }, // 我的首页-机构及用户信息-企业机构管理
  {
    path: 'innerOrgList',
    name: 'innerOrgList',
    meta: {
      title: '企业机构管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['innerOrgList']
    },
    component: function component() {
      return import('@/pages/memberCenter/orgUsersInfoMenu/innerOrgList/innerOrgList');
    }
  }, // 我的首页-机构及用户信息-企业机构管理-新增
  {
    path: 'innerOrgAdd',
    name: 'innerOrgAdd',
    meta: {
      title: '新增企业组织机构',
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/orgUsersInfoMenu/innerOrgList/innerOrgAdd');
    }
  }, // 我的首页-机构及用户信息-企业机构管理-修改
  {
    path: 'innerOrgEdit',
    name: 'innerOrgEdit',
    meta: {
      title: '修改企业组织机构',
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/orgUsersInfoMenu/innerOrgList/innerOrgEdit');
    }
  }, // 我的首页-机构及用户信息-企业机构管理-详情
  {
    path: 'innerOrgDetail',
    name: 'innerOrgDetail',
    meta: {
      title: '组织机构详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/orgUsersInfoMenu/innerOrgList/innerOrgDetail');
    }
  }, // 我的首页-机构及用户管理-客商企业机构管理
  {
    path: 'outerOrgList',
    name: 'outerOrgList',
    meta: {
      title: '客商企业机构管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['outerOrgList']
    },
    component: function component() {
      return import('@/pages/memberCenter/orgUsersInfoMenu/outerOrgList/outerOrgList');
    }
  }, // 我的首页-机构及用户管理-客商企业机构管理-新增
  {
    path: 'outerOrgAdd',
    name: 'outerOrgAdd',
    meta: {
      title: '新增客商组织机构',
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/orgUsersInfoMenu/outerOrgList/outerOrgAdd');
    }
  }, // 我的首页-机构及用户管理-客商企业机构管理-修改
  {
    path: 'outerOrgEdit',
    name: 'outerOrgEdit',
    meta: {
      title: '修改组织机构',
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/orgUsersInfoMenu/outerOrgList/outerOrgEdit');
    }
  }, // 我的首页-机构及用户管理-客商企业机构管理-详情
  {
    path: 'outerOrgDetail',
    name: 'outerOrgDetail',
    meta: {
      title: '客商企业机构详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/orgUsersInfoMenu/outerOrgList/outerOrgDetail');
    }
  }, // 我的首页-客商企业机构管理（内部供应商 ）-修改
  {
    path: 'outSuplierEdit',
    name: 'outSuplierEdit',
    meta: {
      title: '修改客商企业机构',
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/orgUsersInfoMenu/outerOrgList/outSuplierEdit');
    }
  }, // 我的首页-机构及用户管理-企业用户管理
  {
    path: 'innerUserList',
    name: 'innerUserList',
    meta: {
      title: '企业用户管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['innerUserList']
    },
    component: function component() {
      return import('@/pages/memberCenter/orgUsersInfoMenu/innerUserList/innerUserList');
    }
  }, // 我的首页-机构及用户管理-企业用户管理-新增
  {
    path: 'innerUserAdd',
    name: 'innerUserAdd',
    meta: {
      title: '企业用户新增',
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/orgUsersInfoMenu/innerUserList/innerUserAdd');
    }
  }, // 我的首页-机构及用户管理-企业用户管理-修改
  {
    path: 'innerUserEdit',
    name: 'innerUserEdit',
    meta: {
      title: '企业用户修改',
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/orgUsersInfoMenu/innerUserList/innerUserEdit');
    }
  }, // 我的首页-机构及用户管理-企业用户管理-详情
  {
    path: 'innerUserDetail',
    name: 'innerUserDetail',
    meta: {
      title: '企业用户详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/orgUsersInfoMenu/innerUserList/innerUserDetail');
    }
  }, // 我的首页-机构及用户管理-企业用户管理-调岗兼职
  {
    path: 'innerPostTransfer',
    name: 'innerPostTransfer',
    meta: {
      title: '企业用户调岗兼职',
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/orgUsersInfoMenu/innerUserList/innerPostTransfer');
    }
  }, // 我的首页-机构及用户管理-客商企业用户管理
  {
    path: 'outerUserList',
    name: 'outerUserList',
    meta: {
      title: '客商企业用户管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['outerUserList']
    },
    component: function component() {
      return import('@/pages/memberCenter/orgUsersInfoMenu/outerUserList/outerUserList');
    }
  }, // 我的首页-机构及用户管理-客商企业用户管理-新增
  {
    path: 'outerUserAdd',
    name: 'outerUserAdd',
    meta: {
      title: '客商企业用户新增',
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/orgUsersInfoMenu/outerUserList/outerUserAdd');
    }
  }, // 我的首页-机构及用户管理-客商企业用户管理-修改
  {
    path: 'outerUserEdit',
    name: 'outerUserEdit',
    meta: {
      title: '客商企业用户修改',
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/orgUsersInfoMenu/outerUserList/outerUserEdit');
    }
  }, // 我的首页-机构及用户管理-客商企业用户管理-详情
  {
    path: 'outerUserDetail',
    name: 'outerUserDetail',
    meta: {
      title: '客商企业用户详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/orgUsersInfoMenu/outerUserList/outerUserDetail');
    }
  }, // 我的首页-机构及用户管理-客商企业用户管理-调岗兼职
  {
    path: 'outerPostTransfer',
    name: 'outerPostTransfer',
    meta: {
      title: '客商企业用户调岗',
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/orgUsersInfoMenu/outerUserList/outerPostTransfer');
    }
  }, // 我的首页-发票及账套信息-发票信息管理
  {
    path: 'invoiceInfoManage',
    name: 'invoiceInfoManage',
    meta: {
      title: '发票信息管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['invoiceInfoManage']
    },
    component: function component() {
      return import('@/pages/memberCenter/invoiceAccountMenu/invoiceInfoManage/invoiceInfoManage');
    }
  }, // 我的首页-发票及账套信息-发票信息添加
  {
    path: 'invoiceInfoAddForm',
    name: 'invoiceInfoAddForm',
    meta: {
      title: '发票信息新增',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/invoiceAccountMenu/invoiceInfoManage/invoiceInfoAddForm');
    }
  }, // 我的首页-发票及账套信息-发票信息修改
  {
    path: 'invoiceInfoEditForm',
    name: 'invoiceInfoEditForm',
    meta: {
      title: '发票信息修改',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/invoiceAccountMenu/invoiceInfoManage/invoiceInfoEditForm');
    }
  }, // 我的首页-发票及账套信息-发票信息详情
  {
    path: 'invoiceInfoDetails',
    name: 'invoiceInfoDetails',
    meta: {
      title: '发票信息详情',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/invoiceAccountMenu/invoiceInfoManage/invoiceInfoDetails');
    }
  }, // 1menu我的首页-LRS / 2menu我的下载Y / 3menu下载任务
  {
    path: 'myDownloadList',
    name: 'myDownloadList',
    meta: {
      title: '下载任务',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['myDownloadList'] // hidden: true

    },
    component: function component() {
      return import('@/pages/memberCenter/myDownloadMenu/myDownloadList/myDownloadList.vue');
    }
  }, // 1menu我的首页（供应商端） / 2menu入驻管理 / 3menu供应商签约申请
  {
    path: 'supSignApplicationList',
    name: 'supSignApplicationList',
    meta: {
      title: '供应商签约申请',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supSignApplicationList'] // hidden: true

    },
    component: function component() {
      return import('@/pages/memberCenter/supSignApplicationMenu/supSignApplicationList/supSignApplicationList');
    }
  }, // 1menu我的首页（供应商端） / 2menu入驻管理 / 新增签约申请
  {
    path: 'addsupSignApplication',
    name: 'addsupSignApplication',
    meta: {
      title: '新增签约申请',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/supSignApplicationMenu/supSignApplicationList/addsupSignApplication');
    }
  }, // 1menu我的首页（供应商端） / 2menu入驻管理 / 修改签约申请
  {
    path: 'editSupSignApplication',
    name: 'editSupSignApplication',
    meta: {
      title: '修改签约申请',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/supSignApplicationMenu/supSignApplicationList/editSupSignApplication');
    }
  }, // 1menu我的首页（供应商端） / 2menu入驻管理 / 确认签约申请
  {
    path: 'confirmSupSignApplication',
    name: 'confirmSupSignApplication',
    meta: {
      title: '新增签约申请',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/supSignApplicationMenu/supSignApplicationList/confirmSupSignApplication');
    }
  }, // 1menu我的首页（供应商端） / 2menu入驻管理 / 申请中详情
  {
    path: 'applicationingDetails',
    name: 'applicationingDetails',
    meta: {
      title: '申请中详情',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/supSignApplicationMenu/supSignApplicationList/applicationingDetails');
    }
  }, // 1menu我的首页（供应商端） / 2menu入驻管理 / 待确认-签约完成详情
  {
    path: 'supSignApplicationDetails',
    name: 'supSignApplicationDetails',
    meta: {
      title: '申请中详情',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/supSignApplicationMenu/supSignApplicationList/supSignApplicationDetails');
    }
  }, // 我的首页-发票及账套信息-发票接收地址
  {
    path: 'InvoiceReceManage',
    name: 'InvoiceReceManage',
    meta: {
      title: '发票接收地址',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['InvoiceReceManage'] // hidden: true

    },
    component: function component() {
      return import('@/pages/memberCenter/invoiceAccountMenu/InvoiceReceManage/InvoiceReceManage');
    }
  }, // 我的首页-发票及账套信息-发票接收地址新增
  {
    path: 'InvoiceReceAddForm',
    name: 'InvoiceReceAddForm',
    meta: {
      title: '企业发票信息新增',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/invoiceAccountMenu/InvoiceReceManage/InvoiceReceAddForm');
    }
  }, // 我的首页-发票及账套信息-发票接收地址修改
  {
    path: 'InvoiceReceEditForm',
    name: 'InvoiceReceEditForm',
    meta: {
      title: '企业发票信息修改',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/invoiceAccountMenu/InvoiceReceManage/InvoiceReceEditForm');
    }
  }, // 我的首页-发票及账套信息-发票接收地址详情页
  {
    path: 'InvoiceReceDetails',
    name: 'InvoiceReceDetails',
    meta: {
      title: '企业发票信息详情页',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/invoiceAccountMenu/InvoiceReceManage/InvoiceReceDetails');
    }
  }, // 我的首页-发票及账套信息-企业账套信息
  {
    path: 'enterpriseAccInfo',
    name: 'enterpriseAccInfo',
    meta: {
      title: '企业账套信息',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['enterpriseAccInfo'] // hidden: true

    },
    component: function component() {
      return import('@/pages/memberCenter/invoiceAccountMenu/enterpriseAccInfo/enterpriseAccInfo');
    }
  }, // 我的首页-发票及账套信息-企业账套信息新增
  {
    path: 'enterpriseAccInfoAdd',
    name: 'enterpriseAccInfoAdd',
    meta: {
      title: '企业账套信息',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/invoiceAccountMenu/enterpriseAccInfo/enterpriseAccInfoAdd');
    }
  }, // 我的首页-发票及账套信息-企业账套信息修改
  {
    path: 'enterpriseAccInfoEdit',
    name: 'enterpriseAccInfoEdit',
    meta: {
      title: '企业账套信息',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/invoiceAccountMenu/enterpriseAccInfo/enterpriseAccInfoEdit');
    }
  }, // 我的首页-发票及账套信息-企业账套信息详情页
  {
    path: 'enterpriseAccInfoDetails',
    name: 'enterpriseAccInfoDetails',
    meta: {
      title: '企业账套信息',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/invoiceAccountMenu/enterpriseAccInfo/enterpriseAccInfoDetails');
    }
  }, // 我的首页-发票及账套信息-企业账套审核
  {
    path: 'enterpriseExamine',
    name: 'enterpriseExamine',
    meta: {
      title: '企业账套审核',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['enterpriseExamine'] // hidden: true

    },
    component: function component() {
      return import('@/pages/memberCenter/invoiceAccountMenu/enterpriseExamine/enterpriseExamine');
    }
  }, // 我的首页-申请上架管理采购商测
  {
    path: 'applyForListManage',
    name: 'applyForListManage',
    meta: {
      title: '申请上架管理(采购商侧)',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['applyForListManage'] // hidden: true

    },
    component: function component() {
      return import('@/pages/memberCenter/applyForListMenu/applyForListManage/applyForListManage');
    }
  }, // 我的首页-代办管理列表页
  {
    path: 'backlogListManage',
    name: 'backlogListManage',
    meta: {
      title: '待办',
      cache: true // hidden: true

    },
    component: function component() {
      return import('@/pages/memberCenter/backlogListManage/backlogListManage');
    }
  }, // 我的首页-申请上架管理供应商侧
  {
    path: 'applyForListManageSupplier',
    name: 'applyForListManageSupplier',
    meta: {
      title: '申请上架管理(供应商侧)',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['applyForListManageSupplier'] // hidden: true

    },
    component: function component() {
      return import('@/pages/memberCenter/applyForListMenu/applyForListManage/applyForListManageSupplier');
    }
  }, {
    // 申请上架
    path: 'addApplyForList',
    name: 'addApplyForList',
    component: function component() {
      return import('@/pages/memberCenter/applyForListMenu/applyForListManage/addApplyForList');
    },
    meta: {
      title: '新增申请上架',
      cache: false,
      hidden: true
    }
  }, {
    // 申请上架详情
    path: 'detailApplyForList',
    name: 'detailApplyForList',
    component: function component() {
      return import('@/pages/memberCenter/applyForListMenu/applyForListManage/detailApplyForList');
    },
    meta: {
      title: '申请上架详情',
      cache: false,
      hidden: true
    }
  }, // 我的首页-智能客服管理-客户管理
  {
    path: 'supCustomerServiceManage',
    name: 'supCustomerServiceManage',
    meta: {
      title: '客服管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supCustomerServiceManage']
    },
    component: function component() {
      return import('@/pages/memberCenter/supCustomerServiceMenu/supCustomerServiceManage/supCustomerServiceManage');
    }
  }, // 我的首页-智能客服管理-客户管理-新增
  {
    path: 'supCustomerServiceAdd',
    name: 'supCustomerServiceAdd',
    meta: {
      title: '客服管理新增',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/supCustomerServiceMenu/supCustomerServiceManage/supCustomerServiceAdd');
    }
  }, // 我的首页-智能客服管理-客户管理-修改
  {
    path: 'supCustomerServiceEdit',
    name: 'supCustomerServiceEdit',
    meta: {
      title: '客服管理修改',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/memberCenter/supCustomerServiceMenu/supCustomerServiceManage/supCustomerServiceEdit');
    }
  }, // 我的首页-查询分析管理-查询分析
  {
    path: 'queryParsingList',
    name: 'queryParsingList',
    meta: {
      title: '查询分析',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['queryParsingList'] // hidden: true

    },
    component: function component() {
      return import('@/pages/memberCenter/queryParsingMenu/queryParsingList/queryParsingList');
    }
  }, // 1menu我的首页-LRS / 2menu需求反馈 / 3menu我的反馈
  {
    path: 'myFeedback',
    name: 'myFeedback',
    meta: {
      title: '我的反馈',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['myFeedback'] // hidden: true

    },
    component: function component() {
      return import('@/pages/memberCenter/needsFeedbackMenu/myFeedback/myFeedback.vue');
    }
  }, // 1menu我的首页-LRS / 2menu需求反馈 / 3menu我的反馈-详情
  {
    path: 'feedbackDetailP',
    name: 'feedbackDetailP',
    meta: {
      title: '我的反馈详情',
      hidden: true // hidden: true

    },
    component: function component() {
      return import('@/pages/memberCenter/needsFeedbackMenu/myFeedback/feedbackDetailP.vue');
    }
  }, // 1menu我的首页-LRS / 2menu需求反馈 / 3menu反馈管理
  {
    path: 'feedbackManage',
    name: 'feedbackManage',
    meta: {
      title: '反馈管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['feedbackManage'] // hidden: true

    },
    component: function component() {
      return import('@/pages/memberCenter/needsFeedbackMenu/feedbackManage/feedbackManage.vue');
    }
  }, // 1menu我的首页-LRS / 2menu需求反馈 / 3menu反馈管理详情
  {
    path: 'feedbackDetailO',
    name: 'feedbackDetailO',
    meta: {
      title: '反馈管理详情',
      hidden: true // hidden: true

    },
    component: function component() {
      return import('@/pages/memberCenter/needsFeedbackMenu/feedbackManage/feedbackDetailO.vue');
    }
  }, // 1menu我的首页-LRS / 2menu需求反馈 / 3menu反馈管理处理
  {
    path: 'feedbackDeal',
    name: 'feedbackDeal',
    meta: {
      title: '反馈管理-处理',
      hidden: true // hidden: true

    },
    component: function component() {
      return import('@/pages/memberCenter/needsFeedbackMenu/feedbackManage/feedbackDeal.vue');
    }
  }]
};